import { createLogic } from 'redux-logic';
import { removeSBAAuthentication } from 'store/authentication/sba/actions';
import { ssoLogoutSuccess } from 'store/authentication/sso/actions';

const resetStoreState = createLogic({
  type: [removeSBAAuthentication, ssoLogoutSuccess],
  process(deps, dispatch, done) {
    // TODO: consider removing or clearing graphql store here
    // See https://app.clubhouse.io/qantasaccommodation/story/35199/clear-graphql-store-on-logout-in-resetstorestate
    done();
  },
});

export default resetStoreState;
